var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"operative-table-body-row-empty"},[_vm._l((_vm.columns),function(i){return [_c('td',{key:i},[_c('span')])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }